import LBMGraficoExtraPainel from "entity/Indicador/LBM/components/LBMGraficoExtraPainel"
import LCGraficoExtraPainel from "entity/Indicador/LC/components/LCGraficoExtraPainel"
import PerdasGraficoExtraPainel from "entity/Indicador/Perdas/components/PerdasGraficoExtraPainel"

export default function GraficosExtraPainel({ indicadorProps, nomeAgrupador, field }) {
    switch (field) {
        case 'lbm':
            return <LBMGraficoExtraPainel indicadorProps={indicadorProps} nomeAgrupador={nomeAgrupador} />
        case 'lc':
            return <LCGraficoExtraPainel indicadorProps={indicadorProps} nomeAgrupador={nomeAgrupador} />
        case 'perd':
            return <PerdasGraficoExtraPainel indicadorProps={indicadorProps} nomeAgrupador={nomeAgrupador} />
        default:
            return <></>
    }
}